import PropTypes from 'prop-types';
import React from 'react';

import withModifier from '../../twig-extensions/filter/withModifier';

const Text = React.forwardRef(
  ({ className, modifiers = [], children, html, tag, variant }, ref) => {
    const Tag = tag;

    if (html) {
      return (
        <Tag
          ref={ref}
          className={`${withModifier('text', [
            ...modifiers,
            variant
          ])} ${className}`}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      );
    }

    return (
      <Tag
        ref={ref}
        className={`${withModifier('text', [
          ...modifiers,
          variant
        ])} ${className}`}
      >
        {children}
      </Tag>
    );
  }
);

Text.propTypes = {
  className: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  html: PropTypes.string,
  variant: PropTypes.string,
  tag: PropTypes.oneOf([
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h5',
    'h6',
    'span',
    'figcaption',
    'cite',
    'label',
    'legend',
    'small',
    'div'
  ])
};

Text.defaultProps = {
  className: '',
  modifiers: [],
  children: null,
  html: null,
  variant: 'copy',
  tag: 'p'
};

export default Text;
